module.exports = __webpack_public_path__ + "img/img01.98b269a1.jpg";